import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["objectTypeId"];
import formatName from 'I18n/utils/formatName';
import http from 'hub-http/clients/apiClient';
import { propertyEquals, safeGetCrmProperties } from 'personalization-lib/utils/assetData/crm';
import { CRM_OBJECT_TYPE_IDS } from '../../constants/crm';
const BASE_URL = '/crm-search/search';
export const fetchCrmObjectsByType = ({
  objectTypeId,
  filters,
  properties = [],
  search,
  offset,
  limit
}) => http.post(BASE_URL, {
  data: {
    objectTypeId,
    offset: offset !== null && offset !== void 0 ? offset : 0,
    count: limit !== null && limit !== void 0 ? limit : 10,
    query: search,
    filterGroups: [{
      filters
    }],
    requestOptions: {
      properties
    },
    sorts: [{
      property: 'hs_updated_at',
      order: 'DESC'
    }]
  }
});
export function createCrmObjectFetcher(params, resultsMapper) {
  return async paginationParams => {
    const properties = Object.values(params.propertiesMap);
    const response = await fetchCrmObjectsByType(Object.assign({
      objectTypeId: params.objectTypeId,
      properties,
      filters: params.filters
    }, paginationParams));
    const {
      total,
      offset,
      results
    } = response;
    const resultsWithExtractedProperties = results.map(res => safeGetCrmProperties(res, params.propertiesMap));
    return {
      total,
      offset,
      results: resultsMapper ? resultsMapper(resultsWithExtractedProperties) : resultsWithExtractedProperties
    };
  };
}
export const fetchContactOptions = createCrmObjectFetcher({
  objectTypeId: CRM_OBJECT_TYPE_IDS.CONTACT,
  propertiesMap: {
    firstName: 'firstname',
    lastName: 'lastname',
    value: 'hs_object_id'
  }
}, results => results.map(({
  firstName,
  lastName,
  value
}) => ({
  value,
  text: formatName({
    firstName,
    lastName
  })
})));
export const fetchCompanyOptions = createCrmObjectFetcher({
  objectTypeId: CRM_OBJECT_TYPE_IDS.COMPANY,
  propertiesMap: {
    text: 'name',
    value: 'hs_object_id'
  }
});
export const fetchContactListOptions = createCrmObjectFetcher({
  objectTypeId: CRM_OBJECT_TYPE_IDS.CONTACT_LIST,
  propertiesMap: {
    text: 'hs_list_name',
    value: 'hs_object_id'
  },
  filters: [propertyEquals('hs_is_public', 'true'), propertyEquals('hs_object_type_id', CRM_OBJECT_TYPE_IDS.CONTACT)]
});
export const fetchWebVisitorSegmentOptions = createCrmObjectFetcher({
  objectTypeId: CRM_OBJECT_TYPE_IDS.WEB_VISITOR_SEGMENT,
  propertiesMap: {
    text: 'hs_name',
    value: 'hs_object_id'
  }
});
export const fetchCrmObjectOptions = _ref => {
  let {
      objectTypeId
    } = _ref,
    paginationParams = _objectWithoutPropertiesLoose(_ref, _excluded);
  switch (objectTypeId) {
    case CRM_OBJECT_TYPE_IDS.CONTACT:
      return fetchContactOptions(paginationParams);
    case CRM_OBJECT_TYPE_IDS.COMPANY:
      return fetchCompanyOptions(paginationParams);
    case CRM_OBJECT_TYPE_IDS.CONTACT_LIST:
      return fetchContactListOptions(paginationParams);
    case CRM_OBJECT_TYPE_IDS.WEB_VISITOR_SEGMENT:
      return fetchWebVisitorSegmentOptions(paginationParams);
    default:
      throw new Error(`Unknown object type id: ${objectTypeId}`);
  }
};